"use client";
import { useRouter } from "@/i18n/navigation";
import CommonButton from "@/components/Button/CommonButton";

const RedirectButton = ({ route, text, bgColor, hoverColor, textColor, className, svgImages }) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(route);
  };

  return (
    <>
      <CommonButton
        onClick={handleClick}
        text={text}
        bgColor={bgColor}
        hoverColor={hoverColor}
        textColor={textColor}
        className={className}
        svgImages={svgImages}
      />
    </>
  );
};

export default RedirectButton;
